export default __webpack_public_path__ + "media/assets/img/img_icon_quote-9e9ab24ddc67f81ccce91032786968f7.svg";